var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasSubject)?_c('div',{staticClass:"subject",class:_vm.isCurrentSession? 'activeSession' : '',on:{"click":function($event){$event.preventDefault();return _vm.clickActiveSession.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.subject.libelle)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }